import React, { Fragment } from 'react';

import numeral from 'numeral';
import moment from 'moment';

import {
  Box,
  makeStyles,
  TableCell,
  TableRow,
  Tooltip,
  colors,
  Avatar,
  IconButton,
  Icon,
  Grid,
  Link,
  Typography
} from '@material-ui/core';

import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import BuildIcon from '@material-ui/icons/Build';
import { FaMoneyBillWave } from "react-icons/fa";

const useStyles = makeStyles((theme) => ({
  root: {
  },
  avatar: {
    marginRight: theme.spacing(2),
    backgroundColor: colors.grey[200]
  },
  inday: {
    color: colors.green[600],
  },
  cpclate: {
    color: colors.red[600]
  },
  cpalate: {
    color: colors.red[600]
  }
}));

const formatDecimal = (value) => {
  return numeral(value).format('0.00').replace('.', ',');
}

const formatNumber = (value, mask) => {
  return numeral(value).format(mask);
}

const formatDate = (value) => {
  if (value) {
    return moment(value).format('DD/MM/YYYY')
  } else {
    return ""
  }
}

const truncateValue = (value, size) => {
  if (value.length > size) {
    return value.substring(size - 3, 0) + '...';
  } else {
    return value;
  }
}

const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const Record = ({ icon, item, vision, resultMode, openEdition, openDeletion, openTreatment, slas }) => {

  const classes = useStyles();

  const getFieldValue = (column) => {
    try {
      var value = eval(column.field);
      return ((value) ? value : "");
    } catch (error) {
      return "";
    }
  }

  const getStatusSLA = (slas, column, item) => {
    if (item.TIPO_OCORR == 2 || item.TIPO_OCORR == 4) {
      return "";
    } else {
      var style = 0;
      if (column.name == 'CPA' || column.name == 'CPC') {
        var group = (column.name == 'CPA') ? 1 : (column.name == 'CPC') ? 2 : 0;
        slas.forEach(sla => {
          if (sla.ocorrencia == item.id) {
            style = (sla.grupo == 3) ? 3 : group;
          }
        });
      }
      var ret = (style == 1) ? classes.cpalate : (style == 2) ? classes.cpclate : (style == 3) ? classes.inday : "";
      return ret;
    }
  }

  const getStyleActionsAjustment = (resultMode) => {
    var distance = (resultMode.update + resultMode.delete + resultMode.config) * 50;
    return { maxWidth: distance, minWidth: distance };
  }

  const getIconColor = (item) => {
    if (item.realizado == 3) {
      return { color: colors.green[600] }
    } else if (item.servicoExecutado || item.horasExecucaoServico || item.dataConclusaoAtendimento || item.dataInicioAtendimento) {
      return { color: colors.yellow[600] }
    } else {
      return { color: colors.red[600] }
    }
  }

  return (
    <Fragment>

      <TableRow hover key={item.id} className={classes.root}>

        {resultMode.columns.map((col, index) => (
          (index == 0) ? (

            <TableCell>
              <Tooltip title={(item.ORCAMENTO != null) ? 'Valor de Orçamento Registrado: ' + numeral(item.ORCAMENTO).format('0.00') : "Sem Orçamento Registrado"}>
                <Box
                  noWrap={(col.wrap)}
                  alignItems="center"
                  display="flex"
                  component={Link}
                  onClick={() => { (resultMode.update == LEVEL_ACCESS_ENABLED) ? openEdition(item) : {} }}
                >
                  {(item.RAT != null) && (item.RAT != 0) ? <Typography style={{ marginLeft: -14, marginTop: -14, fontSize: '10px', color: colors.blue[500] }} >RAT.</Typography> : ""}
                  {(item.ORCAMENTO != null) ? (item.ORCAMENTO > 0) ? <Icon component={FaMoneyBillWave} style={{ marginLeft: -14, marginTop: 5, width: '16px', color: colors.green[500] }} ></Icon> : <Icon component={FaMoneyBillWave} style={{ marginLeft: -14, marginTop: 5, width: '16px', color: colors.red[500] }} ></Icon> : ""}
                  <Avatar
                    className={classes.avatar}
                  >
                    <Icon component={icon} style={getIconColor(item)} ></Icon>
                  </Avatar>
                  {getFieldValue(col)}
                </Box>
              </Tooltip>
            </TableCell>

          ) : (
            <TableCell className={getStatusSLA(slas, col, item)}  >
              <Typography variant="body" noWrap={(col.wrap)}  >
                {getFieldValue(col)}
              </Typography>
            </TableCell>)
        ))}

        <TableCell align="right" >
          <Grid container style={getStyleActionsAjustment(resultMode)} >
            {(resultMode.config != LEVEL_ACCESS_HIDE) ? (
              <Grid item
                md={4}
                xl={4}
              >
                <Tooltip title="Tratar">
                  <IconButton
                    color="secondary"
                    disabled={resultMode.config == LEVEL_ACCESS_DISABLED}
                    children={<BuildIcon />}
                    size="medium"
                    onClick={() => { openTreatment(item) }}></IconButton>
                </Tooltip>
              </Grid>
            ) : ('')}

            {(resultMode.update != LEVEL_ACCESS_HIDE) ? (
              <Grid item
                md={4}
                xl={4}
              >
                <Tooltip title="Editar">
                  <IconButton
                    color="secondary"
                    disabled={resultMode.update == LEVEL_ACCESS_DISABLED}
                    children={<EditRoundedIcon />}
                    size="medium"
                    onClick={() => { openEdition(item) }}>
                  </IconButton>
                </Tooltip>
              </Grid>
            ) : ('')}

            {(resultMode.delete != LEVEL_ACCESS_HIDE) ? (
              <Grid item
                md={4}
                xl={4}
              >
                <Tooltip title={"Excluir"}>
                  <IconButton
                    color="secondary"
                    disabled={resultMode.delete == LEVEL_ACCESS_DISABLED}
                    children={<DeleteRoundedIcon />}
                    size="medium"
                    onClick={() => { openDeletion(item) }}></IconButton>
                </Tooltip>
              </Grid>
            ) : ('')}

          </Grid>
        </TableCell>

      </TableRow>

    </Fragment >
  );
}

export default Record;